import React from "react";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SideNav from "../components/side-nav-view";
import { stopEvent } from "lib/utility-functions";
import { clientIsAdmin } from "modules/portal-module";

export const SideNavContainer = () => {
  const navigate = useNavigate();
  const { clientIsAdmin } = useSelector(getValuesFromStore);

  const compareRoutes = () => (route) => {
    return window.location.pathname === route;
  };

  const movetoDifferentPage = (e) => (route) => {
    stopEvent(e);
    navigate(route);
    return;
  };

  return (
    <SideNav
      compareRoutes={compareRoutes()}
      movetoDifferentPage={movetoDifferentPage()}
      clientIsAdmin={clientIsAdmin}
    />
  );
};
export const getValuesFromStore = (state) => ({
  clientIsAdmin: clientIsAdmin(state),
});

export default SideNavContainer;
